<template>
    <div class="as-filter-fields">
        <UiInput
            id="player-search"
            :model-value="searchQuery"
            type="search"
            label="Поиск"
            placeholder="Фамилия или имя..."
            autocomplete="off"
            block
            @update:model-value="$emit('update:searchQuery', $event)"
        />

        <section class="as-filter-section">
            <div class="as-filter-section__header">
                <h4 class="as-filter-section__title">Команды</h4>
                <FilterSelectAllButton
                    :all-selected="allTeamsSelected"
                    :disabled="!teamOptions.length"
                    @toggle="$emit('toggle-all-teams')"
                />
            </div>
            <div class="as-filter-checklist">
                <label
                    v-for="option in teamOptions"
                    :key="option.value"
                    class="as-filter-check"
                    :class="{ 'as-filter-check--selected': isTeamSelected(option.value) }"
                >
                    <input
                        v-model="draftFilters.team_ids"
                        type="checkbox"
                        :value="option.value"
                    />
                    <span class="filter-team">
                        <span v-if="option.logo" class="filter-team__logo">
                            <img :src="option.logo" :alt="option.label" />
                        </span>
                        <span v-else class="filter-team__logo filter-team__logo--placeholder" />
                        <span class="as-filter-check__label">{{ option.label }}</span>
                    </span>
                </label>
                <p v-if="!teamOptions.length" class="filter-empty">Нет команд для выбранных сезонов</p>
            </div>
        </section>

        <section class="as-filter-section">
            <div class="as-filter-section__header">
                <h4 class="as-filter-section__title">Позиции</h4>
                <FilterSelectAllButton
                    :all-selected="allPositionsSelected"
                    :disabled="!positionOptions.length"
                    @toggle="$emit('toggle-all-positions')"
                />
            </div>
            <div class="as-filter-checklist">
                <label
                    v-for="option in positionOptions"
                    :key="option.value"
                    class="as-filter-check"
                    :class="{ 'as-filter-check--selected': draftFilters.position_slugs.includes(option.value) }"
                >
                    <input
                        v-model="draftFilters.position_slugs"
                        type="checkbox"
                        :value="option.value"
                    />
                    <span class="as-filter-check__label">{{ option.label }}</span>
                </label>
                <p v-if="!positionOptions.length" class="filter-empty">Нет позиций</p>
            </div>
        </section>

        <section class="as-filter-section">
            <CompetitionStageSelect
                variant="inline"
                :competition-types="draftFilters.competition_types"
                :stages="draftFilters.stages"
                @change="$emit('competition-change', $event)"
            />
        </section>

        <div class="advanced-stats-filters__actions">
            <UiButton variant="primary" block @click="$emit('apply')">Применить</UiButton>
            <UiButton variant="secondary" block @click="$emit('reset')">Сбросить</UiButton>
        </div>
    </div>
</template>

<script setup>
import FilterSelectAllButton from '@/components/advanced-stats/FilterSelectAllButton.vue';
import CompetitionStageSelect from '@/components/filters/CompetitionStageSelect.vue';
import UiButton from '@/components/ui/forms/UiButton.vue';
import UiInput from '@/components/ui/forms/UiInput.vue';

const props = defineProps({
    searchQuery: { type: String, default: '' },
    draftFilters: { type: Object, required: true },
    teamOptions: { type: Array, default: () => [] },
    positionOptions: { type: Array, default: () => [] },
    allTeamsSelected: { type: Boolean, default: false },
    allPositionsSelected: { type: Boolean, default: false },
});

defineEmits([
    'update:searchQuery',
    'toggle-all-teams',
    'toggle-all-positions',
    'competition-change',
    'apply',
    'reset',
]);

function isTeamSelected(teamId) {
    return props.draftFilters.team_ids.some((id) => Number(id) === Number(teamId));
}
</script>
